import qs from 'qs';

import * as constType from '@js/constants/actionsTypes';
import { finalHomeProducts, finalZhHomeAdvData } from '@js/controller/IndexController';

// 新版
import {
  apiGetIndexMiniCartJson,
} from './testJsonApi';

const indexMiddleware = (store) => (next) => (action) => {
  switch (action.type) {
    case 'MID_GET_ZHHOME_ADV': {
      store.dispatch({
        type: constType.CHANGE_EFFECT_ISLOADING,
        payload: true,
      });
      store.dispatch({
        type: constType.GET_ZHHOME_ADV,
        payload: finalZhHomeAdvData,
      });
      store.dispatch({
        type: constType.CHANGE_EFFECT_ISLOADING,
        payload: false,
      });
      return next(action);
    }
    case 'MID_GET_HOME_PRODUCTS': {
      store.dispatch({
        type: constType.CHANGE_EFFECT_ISLOADING,
        payload: true,
      });
      store.dispatch({
        type: constType.GET_HOME_PRODUCTS,
        payload: finalHomeProducts,
      });
      store.dispatch({
        type: constType.CHANGE_EFFECT_ISLOADING,
        payload: false,
      });
      return next(action);
    }
    case 'MID_UPDATE_TRPLUS_OTHERALSOLIKEPRODUCT': {
      store.dispatch({
        type: constType.CHANGE_EFFECT_ISLOADING,
        payload: true,
      });
      store.dispatch({
        type: constType.UPDATE_TRPLUS_OTHERALSOLIKEPRODUCT,
        payload: action.payload,
      });
      store.dispatch({
        type: constType.CHANGE_EFFECT_ISLOADING,
        payload: false,
      });

      return next(action);
    }
    case 'MID_GET_INDEX_MINICART': {
      // store.dispatch({ type: constType.CHANGE_EFFECT_ISLOADING, payload: true });
      apiGetIndexMiniCartJson('get')
        .then((res) => {
          // 檢查回傳訊息
          // 後面要想一下如果回傳訊息為 rtnMsg:"fail" 或者不為 "Success" 要怎麼處理
          // 這裡回傳的格式大概如下：
          /**
           * {
           *  "rtnMsg":"Success",
           *  "rtnJson":{
           *    "vendorCart":[],
           *    "preOrderCart":[],
           *    "groupBuyCart":[],
           *    "Count":0,
           *    "deliveryPickupCart":[]
           *  },
           *  "rtnCode":1
           * }
           */
          let response = JSON.parse(res.data);
          response = response.rtnJson;
          store.dispatch({
            type: constType.UPDATE_MINICARTDATA_DATA,
            payload: response,
          });
          // store.dispatch({ type: constType.CHANGE_EFFECT_ISLOADING, payload: false });
        })
        .catch(() => {

          // const httpStatus = err.response.status;
          // const errorMsg = err.response.data.message;
          // errorHandle(httpStatus, errorMsg);
        });

      return next(action);
    }
    default:
      return next(action);
  }
};

export default indexMiddleware;
